import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiAction } from '../action/api.action';
import { AlertService } from './alert.service';
import { ColumnService } from '../items/columns/column/column.service';
import { AddRowService } from '../component/addrow/addrow.service';
import { ItemSubItemService } from '../component/item/item-subitem.service';
import { ItemPeriodService } from '../component/item/item-period.service';
import { ItemPriceService } from '../component/item/item-price.service';
import { ItemImageService } from '../component/item/item-image.service';
import { CampaignService } from '../component/campaign/campaign.service';
import { RegistryCondService } from '../component/registry/registry-cond.service';
import { RegistryPointService } from '../component/registry/registry-point.service';
import { MailDeliveryService } from '../component/mail_delivery/mail-delivery.service';
import { QuestionnaireService } from '../component/questionnaire/questionnaire.service';
import { TemplateValueService } from '../component/template/template-value.service';
import { ItemBase } from '../models/item/item-base';
import { Error } from '../models/error/error';
//// kts
import { KtsTaskService } from '../projects/kts/component/task/task.service';
import { KtsConstructionTaskService } from '../projects/kts/component/task/construction-task.service';
import { KtsGeneralTaskService } from '../projects/kts/component/task/general-task.service';
import { KtsMultiSelectService } from '../projects/kts/component/multiselect/multiselect.service';
import { KtsMultiSelectPartnerCompanyService } from '../projects/kts/component/multiselect/multiselect-partner-company.service';
import { KtsMultiSelectPartnerUserService } from '../projects/kts/component/multiselect/multiselect-partner-user.service';
import { KtsOutlineService } from '../projects/kts/component/outline/outline.service';
import { KtsConstructionTypeService } from '../projects/kts/component/constructiontype/construction-type.service';
var ValidationService = /** @class */ (function () {
    function ValidationService(logger, apiAction, alertService, columnService, 
    //// kts
    taskService, constructionTaskService, generalTaskService, multiSelectService, multiSelectPartnerCompanyService, multiSelectPartnerUserService, outlineService, constructionTypeService, 
    //// ma31
    addRowService, itemSubItemService, itemPeriodService, itemPriceService, itemImageService, campaignService, registryCondService, registryPointService, mailDeliveryService, questionnaireService, templateValueService) {
        this.logger = logger;
        this.apiAction = apiAction;
        this.alertService = alertService;
        this.columnService = columnService;
        this.taskService = taskService;
        this.constructionTaskService = constructionTaskService;
        this.generalTaskService = generalTaskService;
        this.multiSelectService = multiSelectService;
        this.multiSelectPartnerCompanyService = multiSelectPartnerCompanyService;
        this.multiSelectPartnerUserService = multiSelectPartnerUserService;
        this.outlineService = outlineService;
        this.constructionTypeService = constructionTypeService;
        this.addRowService = addRowService;
        this.itemSubItemService = itemSubItemService;
        this.itemPeriodService = itemPeriodService;
        this.itemPriceService = itemPriceService;
        this.itemImageService = itemImageService;
        this.campaignService = campaignService;
        this.registryCondService = registryCondService;
        this.registryPointService = registryPointService;
        this.mailDeliveryService = mailDeliveryService;
        this.questionnaireService = questionnaireService;
        this.templateValueService = templateValueService;
        this.error = [];
        this.colError = [];
        this.requiredError = false;
        this.duplicationError = false;
        this.items = {};
        this.addRowItems = {};
        this.itemSubItem = [];
        this.itemPeriod = {};
        this.itemPrice = {};
        this.itemImage = {};
        this.campaignSegment = [];
        this.registryPoint = [];
        this.registryCond = [];
        this.questionnaire = [];
        this.templateValue = [];
        this.maildelivery = [];
        this.dataComps = [];
        //// kts
        this.task = [];
        this.constructionTask = [];
        this.generalTask = [];
        this.multiSelect = {};
        this.multiSelectPartnerCompany = {};
        this.multiSelectPartnerUser = {};
        this.outline = [];
        this.reportDownload = [];
        this.constructionType = [];
        this._afterValidSubject = new BehaviorSubject(false);
    }
    ValidationService.prototype.afterValidation = function () {
        this._afterValidSubject.next(true);
    };
    Object.defineProperty(ValidationService.prototype, "afterValidationObservable", {
        get: function () {
            return this._afterValidSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ValidationService.prototype.setMeta = function (meta) {
        if (!meta.components) {
            return;
        }
        this.itemSubItem = [];
        this.getItems(meta.models, meta.components);
    };
    ValidationService.prototype.getItems = function (models, components) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var comp = components_1[_i];
            var component = comp.component;
            var name_1 = comp.name;
            var model = comp.model;
            if (comp.components) {
                this.getItems(models, comp.components);
            }
            if (!name_1) {
                continue;
            }
            if (model && models && models[model] && models[model].items) {
                this.items[name_1] = models[model].items;
            }
            if (component === 'AddRowComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.addRowItems[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'ItemSubItemComponent') {
                this.itemSubItem.push(name_1);
            }
            else if (component === 'ItemPeriodComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.itemPeriod[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'ItemPriceComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.itemPrice[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'ItemImageComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.itemImage[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'CampaignSegmentComponent') {
                this.campaignSegment.push(name_1);
            }
            else if (component === 'RegistryCondComponent') {
                this.registryCond.push(name_1);
            }
            else if (component === 'RegistryPointComponent') {
                this.registryPoint.push(name_1);
            }
            else if (component === 'QuestionnaireComponent') {
                this.questionnaire.push(name_1);
            }
            else if (component === 'TemplateValueComponent') {
                this.templateValue.push(name_1);
            }
            else if (component === 'MailDeliveryComponent') {
                this.maildelivery.push('MailDeliveryMComp');
                // this.maildelivery.push("MailDeliveryContentMComp");
            }
            else if (component === 'MultiUploadComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.addRowItems[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
                //// kts
            }
            else if (component === 'KtsTaskComponent') {
                this.task.push(name_1);
            }
            else if (component === 'KtsConstructionTaskComponent') {
                this.constructionTask.push(name_1);
            }
            else if (component === 'KtsGeneralTaskComponent') {
                this.generalTask.push(name_1);
            }
            else if (component === 'KtsMultiSelectComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.multiSelect[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'KtsMultiSelectPartnerCompanyComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.multiSelectPartnerCompany[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'KtsMultiSelectPartnerUserComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.multiSelectPartnerUser[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'KtsOutlineComponent') {
                this.outline.push(name_1);
            }
            else if (component === 'KtsReportDownloadComponent') {
                this.reportDownload.push(name_1);
            }
            else if (component === 'KtsSupervisorAddRowComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.addRowItems[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
            else if (component === 'KtsConstructionTypeComponent') {
                this.constructionType.push(name_1);
            }
            else if (component === 'KtsMultiUploadComponent') {
                if (typeof this.items[name_1] !== 'undefined') {
                    this.addRowItems[name_1] = this.items[name_1];
                    delete this.items[name_1];
                }
            }
        }
    };
    ValidationService.prototype.validation = function (type, event, compRec, msg) {
        this.error = [];
        this.dataComps = [];
        this.getDataComponent(event);
        var targetComponents = [];
        var data = {};
        var err = false;
        this.requiredError = false;
        this.duplicationError = false;
        if (this.dataComps.length === 0) {
            for (var key in compRec) {
                if (type === 'submit') {
                    var e = this.checkRequired(compRec, key, msg);
                    err = err || e;
                }
                data = Object.assign({}, data, compRec[key]);
            }
        }
        else {
            for (var _i = 0, _a = this.dataComps; _i < _a.length; _i++) {
                var comp = _a[_i];
                var reg = new RegExp('^' + comp + '$');
                for (var key in compRec) {
                    if (key.match(reg)) {
                        if (type === 'submit') {
                            var e = this.checkRequired(compRec, key, msg);
                            err = err || e;
                        }
                        targetComponents.push(key);
                        data = Object.assign({}, data, compRec[key]);
                    }
                }
            }
        }
        var validation = true;
        if (type === 'submit' && err) {
            this.logger.error('validation error:\n  - ' + this.error.join('\n  - '));
            if (this.requiredError && this.duplicationError) {
                this.alertService.alert(Object.assign(new Error(), { message: msg['au.COMPONENTS.validate.input'] }));
            }
            else if (this.requiredError && !this.duplicationError) {
                this.alertService.alert(Object.assign(new Error(), { message: msg['au.COMPONENTS.validate.required'] }));
            }
            else if (!this.requiredError && this.duplicationError) {
                this.alertService.alert(Object.assign(new Error(), { message: msg['au.COMPONENTS.validate.duplicated'] }));
            }
            this.columnService.addError(targetComponents);
            validation = false;
            this.afterValidation();
        }
        return { validation: validation, data: data, targetComponents: targetComponents };
    };
    ValidationService.prototype.getDataComponent = function (e) {
        if (e.action === 'Api') {
            if (typeof e.params['dataComponent'] !== 'undefined') {
                this.dataComps = this.dataComps.concat(this.apiAction.getDataComponent(e.params['dataComponent']));
            }
            else if (typeof e.params['request'] !== 'undefined' && e.params['request'] instanceof Array) {
                for (var _i = 0, _a = e.params['request']; _i < _a.length; _i++) {
                    var request = _a[_i];
                    if (typeof request.dataComponent !== 'undefined') {
                        this.dataComps = this.dataComps.concat(this.apiAction.getDataComponent(request.dataComponent));
                    }
                    else if (typeof request.listDataComponent !== 'undefined') {
                        this.dataComps = this.dataComps.concat(this.apiAction.getDataComponent(request.listDataComponent));
                    }
                }
            }
        }
        if (e.events) {
            for (var _b = 0, _c = Object.keys(e.events); _b < _c.length; _b++) {
                var key = _c[_b];
                this.getDataComponent(e.events[key]);
            }
        }
    };
    ValidationService.prototype.checkRequired = function (compRec, key, msg) {
        var _this = this;
        this.colError = [];
        if (this.items[key] && !this.checkItems(this.items[key], compRec[key])) {
            this.error.push(key + '\n  -- ' + this.colError.join('\n  -- '));
            this.requiredError = true;
        }
        else if (this.addRowItems[key]) {
            var cols = this.addRowItems[key];
            var recs = compRec[key];
            if (cols.length === 0 || !cols[0].key || !cols[0].items) {
                return false;
            }
            var items = recs[cols[0].key] || [];
            var count = 0;
            var check_1 = true;
            for (var i = 0; i < items.length; i++) {
                if (items[i].$type === "delete" /* Delete */) {
                    continue;
                }
                if (!this.checkItems(cols[0].items, items[i])) {
                    check_1 = false;
                    this.colError[this.colError.length - 1] = '[' + i + '] ' + this.colError[this.colError.length - 1];
                }
                count++;
            }
            var noRow = false;
            if (cols[0].required && count === 0) {
                this.colError.push('There is no row.');
                check_1 = false;
                noRow = true;
            }
            if (!check_1) {
                this.requiredError = true;
            }
            var errItems = this.addRowService.checkDuplicate(key, items, msg);
            errItems.forEach(function (item, i) {
                Object.keys(item).filter(function (key) { return item[key].length > 0; }).forEach(function (key) {
                    check_1 = false;
                    _this.duplicationError = true;
                    _this.colError.push('[' + i + '] ' + key + ' is duplicated.');
                });
            });
            if (!check_1) {
                this.addRowService.next(key, noRow, errItems);
                this.error.push(key + '\n  -- ' + this.colError.join('\n  -- '));
            }
        }
        else if (this.itemSubItem.indexOf(key) >= 0 && !this.itemSubItemService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.itemPeriod[key] && !this.itemPeriodService.checkItem(this.itemPeriod[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.itemPrice[key] && !this.itemPriceService.checkItem(this.itemPrice[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.itemImage[key] && !this.itemImageService.checkItem(this.itemImage[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.campaignSegment.indexOf(key) >= 0 && !this.campaignService.checkSegmentItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.registryCond.indexOf(key) >= 0 && !this.registryCondService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.registryPoint.indexOf(key) >= 0 && !this.registryPointService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.questionnaire.indexOf(key) >= 0 && !this.questionnaireService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.templateValue.indexOf(key) >= 0 && !this.templateValueService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.maildelivery.indexOf(key) >= 0 && !this.mailDeliveryService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
            //// kts
        }
        else if (this.task.indexOf(key) >= 0 && !this.taskService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.constructionTask.indexOf(key) >= 0 && (!this.constructionTaskService.checkItem(compRec[key]) || !this.constructionTaskService.checkDocuments(compRec[key + '#documents']))) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.generalTask.indexOf(key) >= 0 && !this.generalTaskService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.multiSelect[key] && !this.multiSelectService.checkItem(this.multiSelect[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.multiSelectPartnerCompany[key] && !this.multiSelectPartnerCompanyService.checkItem(this.multiSelectPartnerCompany[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.multiSelectPartnerUser[key] && !this.multiSelectPartnerUserService.checkItem(this.multiSelectPartnerUser[key], compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.outline.indexOf(key) >= 0 && !this.outlineService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.reportDownload.indexOf(key) >= 0 && !this.checkVal(Object.assign(new ItemBase(), { key: 'file' }), compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        else if (this.constructionType.indexOf(key) >= 0 && !this.constructionTypeService.checkItem(compRec[key])) {
            this.error.push(key);
            this.requiredError = true;
        }
        return this.requiredError || this.duplicationError;
    };
    ValidationService.prototype.checkItems = function (items, rec) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (!item.required && item.controlType !== 'file') {
                continue;
            }
            if (!this.checkVal(item, rec)) {
                return false;
            }
            if (item.items) {
                if (!this.checkChildren(item.items, rec)) {
                    return false;
                }
            }
            else {
                var itm = this.columnService.getSwitchItems(item, rec[item.key]);
                if (!this.checkChildren(itm, rec)) {
                    return false;
                }
            }
        }
        return true;
    };
    ValidationService.prototype.checkChildren = function (items, rec) {
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (!this.checkVal(item, rec)) {
                return false;
            }
        }
        return true;
    };
    ValidationService.prototype.checkVal = function (item, rec) {
        if (item.key) {
            if (!this.columnService.checkItemVal(item, rec[item.key])) {
                this.colError.push(item.key + ' is not set.');
                return false;
            }
        }
        else if (!item.key && item.controlType === 'displayTarget') {
            if (!this.columnService.checkItemVal(item, rec)) {
                this.colError.push('display_target is not set.');
                return false;
            }
            //// kts
        }
        else if (!item.key && item.controlType === 'constructionClassification') {
            if (!this.columnService.checkItemVal(item, rec)) {
                this.colError.push('construction_classification is not set.');
                return false;
            }
        }
        else if (!item.key && item.controlType === 'department') {
            if (!this.columnService.checkItemVal(item, rec)) {
                this.colError.push('department is not set.');
                return false;
            }
        }
        return true;
    };
    ValidationService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ValidationService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiAction },
        { type: AlertService },
        { type: ColumnService },
        { type: KtsTaskService },
        { type: KtsConstructionTaskService },
        { type: KtsGeneralTaskService },
        { type: KtsMultiSelectService },
        { type: KtsMultiSelectPartnerCompanyService },
        { type: KtsMultiSelectPartnerUserService },
        { type: KtsOutlineService },
        { type: KtsConstructionTypeService },
        { type: AddRowService },
        { type: ItemSubItemService },
        { type: ItemPeriodService },
        { type: ItemPriceService },
        { type: ItemImageService },
        { type: CampaignService },
        { type: RegistryCondService },
        { type: RegistryPointService },
        { type: MailDeliveryService },
        { type: QuestionnaireService },
        { type: TemplateValueService }
    ]; };
    return ValidationService;
}());
export { ValidationService };
//# sourceMappingURL=validation.service.js.map